<div class="chat-container" id="chat-container" [class.details-open]="runtime.showDetails" (click)="onChatClicked($event)">
  <!-- Pista flotante que sigue al cursor sobre las respuestas del bot (doble clic -> fuentes) -->
  <div #cursorHint class="cursor-hint" aria-hidden="true" id="chat-cursor-hint">
    <i class="fas fa-mouse-pointer"></i>
    <span>{{ translate('chat.double_click_hint') }}</span>
  </div>
  <!-- Popup para consulta CSV/Excel -->
  <app-query-csv-popup *ngIf="runtime.showCsvModal" [query]="runtime.pendingQuery" [csvDocuments]="runtime.csvDocuments"
    (cancel)="onCsvCancel()" (submit)="onCsvSubmit($event)" id="chat-query-csv-popup"></app-query-csv-popup>
  <!-- Panel de chat -->
  <div class="chat-main" [ngClass]="{ 'with-details': runtime.showDetails }" id="chat-main">
    <!-- Cabecera -->
    <div class="chat-header d-flex align-items-center justify-content-between" id="chat-header">
      <div style="display:flex; flex-direction:column; gap:6px;">
        <h1 class="chat-title" id="chat-title">
          <i class="fas fa-comments" id="chat-title-icon"></i> {{ translate('chat.title') || 'Asistente de Documentos'
          }}
        </h1>
        <!-- Mostrar documento limitado si existe -->
        <div *ngIf="runtime.limitedDocId" class="chat-limited-doc" id="chat-limited-doc"
          style="font-size:0.95rem; color:var(--text-secondary); display:flex; align-items:center; gap:8px;">
          <i class="fas fa-file-alt" style="color:var(--primary);"></i>
          <span id="chat-limited-doc-name">{{ runtime.limitedDocName }}</span>
          <button type="button" title="Deseleccionar documento" class="btn btn-sm btn-outline-secondary"
            (click)="onClearLimitedDoc()" id="chat-clear-limited-doc-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <button class="btn btn-sm btn-outline-primary mobile-chat-options-button" type="button"
        (click)="runtime.mobileChatOptionsOpen = !runtime.mobileChatOptionsOpen" [attr.aria-expanded]="runtime.mobileChatOptionsOpen"
        id="chat-mobile-options-btn">
        <i class="fas fa-sliders-h" aria-hidden="true"></i>
        {{ translate('common.options') || 'Opciones' }}
      </button>
      <div class="d-flex flex-row align-items-center gap-2 chat-header-btns" [class.mobile-open]="runtime.mobileChatOptionsOpen" id="chat-header-btns">
        <!-- Dropdown Tipo de búsqueda (preserve numeric values) -->
        <div class="topk-select-wrapper">
          <label for="topk-select">{{ translate('chat.search_type') }}</label>
          <select id="topk-select" class="form-select form-select-sm" [(ngModel)]="runtime.topK" (change)="setTopK(runtime.topK)">
            <option [ngValue]="5">{{ translate('chat.search_type.light') }}</option>
            <option [ngValue]="15">{{ translate('chat.search_type.default') }}</option>
            <option [ngValue]="25">{{ translate('chat.search_type.medium') }}</option>
            <option [ngValue]="50">{{ translate('chat.search_type.strong') }}</option>
          </select>
        </div>
        <button class="btn btn-sm btn-outline-primary details-toggle" (click)="toggleDetails(); runtime.mobileChatOptionsOpen = false"
          id="chat-toggle-details-btn">
          <i class="fas" [ngClass]="runtime.showDetails ? 'fa-times' : 'fa-info-circle'" id="chat-toggle-details-icon"></i>
          {{ runtime.showDetails ? translate('chat.hide_details') : translate('chat.show_details') }}
        </button>
        <button class="btn btn-sm btn-outline-danger" (click)="clearChatHistory(); runtime.mobileChatOptionsOpen = false" id="chat-clear-btn">
          <i class="fas fa-trash" id="chat-clear-icon"></i>
          {{ translate('chat.clear') }}
        </button>
      </div>
    </div>

    <app-chat-conversation [view]="runtime"></app-chat-conversation>
    <app-chat-composer [view]="runtime"></app-chat-composer>
  </div>

  <app-chat-sources-panel [view]="runtime"></app-chat-sources-panel>
  <app-chat-session-dialog [view]="runtime"></app-chat-session-dialog>
  <div *ngIf="runtime.isRequesting" class="chat-spinner-overlay" id="chat-spinner-overlay">
    <mat-spinner diameter="60" id="chat-mat-spinner"></mat-spinner>
    <div class="chat-spinner-text" id="chat-spinner-text">
      {{ translate('upload.processing') }}
    </div>
  </div>
</div>
